import { list } from "@mc/mc-legacy";
import QSignDataApi from "../api/gen/qsign/QSignDataApi";
export const ODMITNUTE_DOKUMENTY_LIST = "odmitnuteDokumentyList";

const getRequestsByIds = (ids) => {
  return QSignDataApi.findRequestDocumentsByIds(ids);
};

const getPozadavkyAllIds = (parent, filter) => {
  return QSignDataApi.findOdmitnuteDokumenty();
};

export function fetchIfNeeded(forceFetch) {
  return (dispatch) => {
    dispatch(
      list.InfiniteListActions.fetchIfNeeded(
        ODMITNUTE_DOKUMENTY_LIST,
        null,
        getPozadavkyAllIds,
        getRequestsByIds,
        forceFetch
      )
    );
  };
}
export function loadMore() {
  return (dispatch, getState) => {
    dispatch(list.InfiniteListActions.loadMore(ODMITNUTE_DOKUMENTY_LIST, getRequestsByIds));
  };
}
export function invalidatePozadavky() {
  return (dispatch) => {
    dispatch(list.InfiniteListActions.invalidate(ODMITNUTE_DOKUMENTY_LIST));
  };
}
export function filterPozadavky(filter) {
  return (dispatch) => {
    dispatch(list.InfiniteListActions.filter(ODMITNUTE_DOKUMENTY_LIST, filter));
  };
}
